module.exports = __webpack_public_path__ + "static/media/MHRP39N0011.c9573684.svg";